export const REDUCER_NAME = "teamNews";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_TEAMNEWS = `${REDUCER_NAME}/SET_TEAMNEWS`;
export const RESET_TEAMNEWS = `${REDUCER_NAME}/RESET_TEAMNEWS`;

export const getKey = (data) => `${data.isFeatured || false}`;
